// PATCH oct21-ui-base: one date format for the whole app.
// fmtDateTime -> "Wed, Oct 21 · 1:18 p.m."   fmtDate -> "Wed, Oct 21"   fmtTime -> "1:18 p.m."
// The year is added only when it is not the current year.
function toDate(v) {
  var d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
}
export function fmtDate(v) {
  var d = toDate(v);
  if (!d) return "";
  var opts = { weekday: "short", month: "short", day: "numeric" };
  if (d.getFullYear() !== new Date().getFullYear()) opts.year = "numeric";
  return d.toLocaleDateString("en-US", opts);
}
export function fmtTime(v) {
  var d = toDate(v);
  if (!d) return "";
  var h = d.getHours();
  var m = String(d.getMinutes()).padStart(2, "0");
  var ap = h < 12 ? "a.m." : "p.m.";
  h = h % 12 || 12;
  return h + ":" + m + " " + ap;
}
export function fmtDateTime(v) {
  var d = toDate(v);
  if (!d) return "";
  return fmtDate(d) + " · " + fmtTime(d);
}
